/**
 * Created by henian.xu on 2020/4/7.
 *
 */

import { get } from 'api/request';

export function memberApplyMaterialsList({ currentPage, pageSize }) {
    return get(this.url, { currentPage, pageSize });
}
